// The parts of the payload today's inventory rules read. The rules are JsonPath configured in Lasta,
// so this list is not guaranteed: if a rule starts reading another field, a change to that field
// keeps the previous result visible while the request runs, and the response then corrects it.
// Fields left out on purpose (version, automation, validationResult, lookupOverrides) change on
// /validate responses and automation updates without changing the answer.
export const getInventoryValidationSignature = (transaction) =>
    JSON.stringify({
        vehicle: transaction?.vehicle,
        trailer: transaction?.trailer,
        companyOfTrailerOwner: transaction?.companyOfTrailerOwner,
        // Prefix of "organization" reference ids.
        companyName: transaction?.person?.companyName,
    });
